export const CRUST_EXTRA = 'Корочка';
export const CRUST_EXTRA_EN = 'Crust';
export const CRUST_EXTRA_PL= 'Skorupa';
export const MOZZARELLA = 'сыр моцарелла';
export const MOZZARELLA_EN = 'mozzarella cheese';
